import React from "react";

export const About = (props) => {
  return (
    <section id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6 about-visual-wrap">
            <div className="about-visual">
              <img src="img/about.jpg" className="img-responsive" alt="A creative professional working at a computer" />
              <div className="about-image-caption">
                <span className="caption-mark"><i className="fa fa-handshake-o" aria-hidden="true"></i></span>
                <span><strong>Technology with people in mind</strong><small>A collaborative approach, from day one</small></span>
              </div>
              <div className="about-year">EST. <strong>2020</strong></div>
            </div>
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <span className="section-kicker">A LITTLE ABOUT US</span>
              <h2>About Us</h2>
              <p>{props.data ? props.data.paragraph : "loading..."}</p>
              <h3>Why Choose Us?</h3>
              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why.map((d, i) => (
                          <li key={`${d}-${i}`}>{d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why2.map((d, i) => (
                          <li key={`${d}-${i}`}> {d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
